import React from 'react';
import PropTypes from 'prop-types'
import TextAreaComponent from './base/TextAreaComponent';

const SpecialInstruction = (props) => {
  const name = 'special_instructions';
  const onChange = e => props.onChangeParameter(name, e.target.value);

  return (
    <TextAreaComponent
      label="Special Instruction"
      name={name}
      onChange={onChange}
      value={props.parameters[name]}
      groupName={props.groupName}
      prefix_name={props.prefix_name} />
  );
};

SpecialInstruction.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
};

export default SpecialInstruction;
